import styled from 'styled-components';

export const StyledStrong = styled.strong`
  font-weight: 500;
`;
